<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex style="text-align:left;">
        <span
          style="text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:18px;"
        >
          <v-icon style="color:black;font-size:14px;">mdi-circle-outline</v-icon>Add a Product
        </span>
      </v-flex>
    </v-layout>
    <br />
    <v-card class="mx-auto" outlined>
      <v-layout wrap pt-3>
        <v-flex md1 lg1>
          <v-img src="./../../../assets/webpeedika.png" aspect-ratio="1" contain height="30px"></v-img>
        </v-flex>
        <v-flex md10 lg10 pb-3>
          <v-layout wrap>
            <v-flex md7 lg7 style="text-align:left;">
              <span
                style="padding-left:10px;text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:12px;"
              >Name of the Product</span>
              <v-autocomplete
                v-model="name"
                :items="productNames"
                item-color="blue"
                hide-no-data
                hide-selected
                outlined
                placeholder="Start typing to Search"
                :search-input.sync="search"
                color="#63028F"
                dense
              ></v-autocomplete>
              <!-- {{product.adminproductid}} -->
              <v-layout wrap>
                <v-flex md3 lg3>
                  <span
                    style="padding-left:10px;text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:12px;"
                  >Unit</span>
                  <v-text-field
                    placeholder="Weight"
                    readonly
                    disabled
                    v-model="product.unit"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex pl-2 md3 lg3>
                  <span
                    style="padding-left:10px;text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:12px;"
                  >Stock</span>
                  <v-text-field
                    placeholder="Stock"
                    v-model="product.stockquantity"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex pl-2 md3 lg3>
                  <span
                    style="padding-left:10px;text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:12px;"
                  >Price</span>
                  <v-text-field
                    placeholder="Price"
                    type="number"
                    v-model="product.price"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex pl-2 md3 lg3>
                  <span
                    style="padding-left:10px;text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:12px;"
                  >Offer %</span>
                  <v-text-field
                    placeholder="Offer Price"
                    style="max-height: 46px!important;"
                    type="number"
                    v-model="product.offer"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md2 lg2 pl-3 style="text-align:left">
              <v-radio-group v-model="inStock">
                <span
                  style="text-align:left;font-family:opensansextrabold ;letter-spacing: 0.54px;font-size:12px;"
                  class="pl-1 pb-2"
                >Status</span>
                <v-radio label="Active" :value="true" color="#63028F"></v-radio>
                <v-radio label="Inactive" :value="false" color="#63028F"></v-radio>
              </v-radio-group>

              <span>
                <v-btn
                  v-if="inStock==true"
                  block
                  small
                  dark
                  color="#FFBC6E"
                  depressed
                  class="text-capitalize"
                  :ripple="false"
                >
                  <v-icon style="color:white;">mdi-check</v-icon>Available
                </v-btn>
                <v-btn
                  v-if="inStock==false"
                  block
                  small
                  dark
                  color="#EB6359"
                  depressed
                  class="text-capitalize"
                  :ripple="false"
                >
                  <v-icon style="color:white;">mdi-close</v-icon>Out of Stock
                </v-btn>
              </span>
            </v-flex>
            <v-flex md3 lg3 pl-3 style="text-align:left">
              <v-card pr-4flat tile outlined>
                <v-layout wrap>
                  <v-flex md4 lg4>
                    <v-img :src="'http://13.235.2.39/u/'+image" height="113px" contain></v-img>
                  </v-flex>
                  <v-flex pl-2 md6 lg6>
                    <v-layout wrap>
                      <v-flex
                        pt-2
                        md6
                        v-for="(item,i) in imageArray"
                        :key="i"
                        px-2
                        class="hidden-sm-and-down"
                      >
                        <v-img
                          v-if="item"
                          :src="'http://13.235.2.39/u/'+item"
                          height="44px"
                          width="44px"
                        ></v-img>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>

              <br />
              <span>
                <v-btn
                  small
                  :ripple="false"
                  id="pro_pic"
                  class="text-capitalize"
                  color="#EFEFEF "
                  width="80%"
                  @click="$refs.files.click()"
                >
                  <v-layout wrap justify-center>
                    <v-flex xs8 text-right>
                      <span style="font-size:12px;font-family:opensanssemibold">Upload Image</span>
                    </v-flex>
                    <v-flex xs4 text-left>
                      <v-img
                        src="./../../../assets/images/fileupload.png"
                        aspect-ratio="1"
                        contain
                        height="16px"
                      >
                        <template v-slot:placeholde>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </v-btn>
                <input
                  v-show="false"
                  accept="image/*"
                  id="file"
                  ref="files"
                  multiple="multiple"
                  type="file"
                  @change="uploadImages"
                />
              </span>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout pt-3 wrap>
            <v-flex md3 lg3>
              <v-text-field
                v-model="product.productcode"
                label="Product ID "
                style="max-height: 46px!important;"
                color="#63028F"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex md3 lg3>
              <span
                style="font-family:opensansregular;font-size:14px;color:#616161"
              >Item Added 12 July 2020</span>
            </v-flex>-->
            <v-flex md3 offset-md6 lg3>
              <v-btn
                block
                dark
                color="#63028F"
                depressed
                class="text-capitalize"
                :ripple="false"
                @click="addProduct()"
              >Apply</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md1 lg1>
          <v-img
            src="./../../../assets/images/savedIcon.png"
            aspect-ratio="1"
            contain
            height="30px"
          ></v-img>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      imageArray: [],
      Images: new FormData(),
      selectedFiles: null,
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showsnackbar: false,
      image: null,
      radio: null,
      status: null,
      search: null,
      name: null,
      productNames: [],
      productData: [],
      pid: "",
      // inStock: true,
      user: {},
      product: {
        adminproductid: null,
        keywords: [],
        productname: null,
        category: null,
        price: null,
        instock: null,
        stockquantity: null,
        description: null,
        unit: null,
        isseasonal: null,
        isinseason: null,
        highlights: null,
        specifications: [],
        productcode: null,
        offer: null,
      },
    };
  },
  beforeMount() {
    axios({
      method: "GET",
      url: "/adminproduct/search",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
      params: { keyword: "" },
    })
      .then((response) => {
        if (response.data.status) {
          this.ProductData = response.data.data;
          if (this.productData.length > 0) {
            for (var i = 0; i < this.productData.length; i++) {
              this.productData[i].price = this.productData[i].mrp;
              this.productData[i].offer = 0;
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  computed: {
    inStock() {
      if (this.product.stockquantity > 0) {
        return true;
      } else if (this.product.stockquantity == null) return null;
      else return false;
    },
  },
  watch: {
    search(val) {
      if (this.search) this.adminSearch(val);
    },
    name() {
      for (var i = 0; i < this.ProductData.length; i++) {
        if (this.name == this.ProductData[i].productname) {
          this.pid = this.ProductData[i]._id;
        }
        if (this.name == "" || this.name == null) {
          this.product = [];
        }
      }
    },
    pid() {
      this.productInfo(this.pid);
    },
  },

  methods: {
    uploadImages(event) {
      this.selectedFiles = event.target.files[0];
      this.Images.append("image", this.selectedFiles);
      console.log("files", this.Images);
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        const urls = URL.createObjectURL(this.selectedFiles);
        if (this.imageArray.length < 4) {
          this.imageArray.push(urls);
        } else {
          this.seen = false;
          this.msg = "Four Images Already Added!";
          //this.showsnackbar = true;
        }
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },

    adminSearch(val) {
      axios({
        method: "GET",
        url: "/adminproduct/search",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { keyword: val },
      })
        .then((response) => {
          if (response.data.status) {
            for (var i = 0; i < response.data.data.length; i++) {
              this.productNames.push(response.data.data[i].productname);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    productInfo(val) {
      axios({
        method: "GET",
        url: "/adminproduct/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: val },
      })
        .then((response) => {
          if (response.data.status) {
            this.product = response.data.data;
            this.product.instock = response.data.data.instock;
            this.product.adminproductid = response.data.data._id;
            this.product.price = response.data.data.mrp;
            this.product.offer = 0;
            this.imageArray = response.data.data.photos;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showImage(item) {
      this.image = item;
    },
    addProduct() {
      if (this.product.adminproductid) {
        this.appLoading = true;
        // evt.preventDefault();
        this.product.instock = this.inStock;
        let quantity = parseInt(this.product.stockquantity, 10);
        let price = parseInt(this.product.price, 10);
        this.product.stockquantity = quantity;
        this.product.price = price;
        this.product.isdefault = true;
        axios({
          method: "POST",
          url: "/product/Add",
          data: this.product,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.$emit("stepper", {
                getList: true,
              });
              this.showsnackbar = true;
              this.msg = response.data.msg;
              this.product = {};
              this.name = null;
            } else {
              this.$emit("stepper", {
                getList: false,
              });
              this.showsnackbar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.ServerError = true;
            console.log(err);
          });
      } else {
        this.showsnackbar = true;
        this.msg = "Please Select a Product Name & fill out the fields";
      }
    },
  },
};
</script>
<style  scoped>
.v-input__slot {
  min-height: 36px;
}
</style>